












































import {Component, Vue, Watch} from 'vue-property-decorator';
import {WebService} from '@/services/web.service';
import {AuthStore} from '@/store/modules/auth.store';
import {TicketStore} from '@/store/modules/ticket.store';
import {LocationStore} from '@/store/modules/location.store';
import IconHamburger from '@/assets/icon-hamburger.svg';
import ZCLogo from '@/assets/white-logo.svg';
import {BadgeStore} from '@/store/modules/badge.store';
import Drawer from '@/components/Drawer.vue';
import ActiveTickets from '@/components/ActiveTickets.vue';
import Waitlist from '@/components/Waitlist.vue';
import LoginOverlay from '@/components/LoginOverlay.vue';
import AddToHomescreen from '@/components/AddToHomescreen.vue';

@Component({
	components: {
		IconHamburger,
		ZCLogo,
		drawer: Drawer,
		'active-tickets': ActiveTickets,
		waitlist: Waitlist,
		'login-overlay': LoginOverlay,
		'add-to-homescreen': AddToHomescreen
	},
})
export default class App extends Vue {
	showLoginOverlay = false;
	showAddToHomescreen = false;

	showTickets = false;
	showWaitlist = false;
	showDrawer = false;

	created() {

	}


	get activeTickets() {
		return TicketStore.active;
	}

	get location() {
		return LocationStore.location;
	}

	get waitlist() {
		return TicketStore.waitlist;
	}

	openMenu() {
		this.showDrawer = true;
	}

	openTickets() {
		this.showTickets = true;
	}

	openWaitlist() {
		this.showWaitlist = true;
	}

	mounted() {
		this.onAuthChange();
	}

	get authCredentials() {
		return AuthStore.authCredentials;
	}

	@Watch('authCredentials')
	@Watch('$route.name')
	async onAuthChange() {
		if(this.$route.name !== 'Launch' && this.$route.name !== null) {
			if(this.authCredentials !== null) {
				if(await WebService.testAuth(this.authCredentials.host, this.authCredentials.locationBase, this.authCredentials.apiKey)) {
					await WebService.start(
						this.authCredentials.host,
						this.authCredentials.locationBase,
						this.authCredentials.apiKey
					);
					this.showLoginOverlay = false;
					if(!AuthStore.promptedToAddToHomescreen && this.getOS() === 'iOS') {
						this.showAddToHomescreen = true;
						AuthStore.setPromptedToAddToHomescreen(true);
					}
				} else {
					await this.$bvModal.msgBoxOk( 'Credentials invalid, please login again', {
						title: 'Error',
						centered: true,
						okTitle: 'Ok'
					});
					this.showLoginOverlay = true;
					AuthStore.clearAuthCredentials();
				}
			} else {
				this.showLoginOverlay = true;
				this.showDrawer = false;
				WebService.stop();
				TicketStore.clearTickets();
				BadgeStore.clearBadges();
				LocationStore.clearLocation();
				if(this.$route.name !== 'Home') {
					this.$router.push('/');
				}
			}
		} else {
			this.showLoginOverlay = false;
		}
	}


	 getOS() {
		const userAgent = window.navigator.userAgent;
		const platform = window.navigator.platform;
		const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
		const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
		const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
		let os = null;

		if (macosPlatforms.indexOf(platform) !== -1) {
			os = 'Mac OS';
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			os = 'iOS';
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
			os = 'Windows';
		} else if (/Android/.test(userAgent)) {
			os = 'Android';
		} else if (!os && /Linux/.test(platform)) {
			os = 'Linux';
		}

		return os;
	}

}
